import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import { UpdateInfo } from '../../view/home/util/useUpdate';
import {RootState} from "../store";

// Define a type for the slice state
interface VmStatusState {
    show: boolean
    info?: Omit<UpdateInfo, "beta">
}

// Define the initial state using that type
const initialState: VmStatusState = {
    show: false,
}

export const updateModalSlice = createSlice({
    name: 'updateModal',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        setUpdateModalShow: (state, action: PayloadAction<boolean>) => {
            state.show = action.payload;
        },
        setUpdateModalInfo: (state, action: PayloadAction<Omit<UpdateInfo, "beta">>) => {
            state.info = action.payload;
        },
    },
})

export const {setUpdateModalShow, setUpdateModalInfo} = updateModalSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectUpdateModal = (state: RootState) => state.updateModal

export default updateModalSlice.reducer
